import React, { ReactElement } from "react";
import { Button } from "@mui/material";

interface ButtonProps {
	text: string;
	startIcon?: ReactElement;
	endIcon?: ReactElement;
	disabled?: boolean;
	onClick: () => void;
}

const GenericButton: React.FunctionComponent<ButtonProps> = ({
	text,
	startIcon,
	endIcon,
	disabled = false,
	onClick,
}) => {
	return (
		<Button
			startIcon={startIcon}
			endIcon={endIcon}
			disabled={disabled}
			onClick={onClick}
			sx={{
				paddingLeft: "15px",
				paddingRight: "15px",
				width: "auto",
				height: "60px",
				textTransform: "none",
				fontSize: "18px",
				"& .MuiButton-startIcon": {
					marginLeft: text ? "-4px" : "0px",
					marginRight: text ? "8px" : "0px",
				},
			}}
		>
			{text}
		</Button>
	);
};

export default GenericButton;
